module.exports = __webpack_public_path__ + "media/images/stage2-f4dd7b95.png";